import { Button, ButtonGroup, Input } from '@chakra-ui/react';
import { EditorState } from 'draft-js';
import * as React from 'react';

import { EPrepImagesSource } from '@/graphql-types/globalTypes';
import { useDraftResources } from '@/hooks/useDraftResources';
import { useImageUpload } from '@/hooks/useImageUpload';

export const ImageUpload: React.FC<{
  editorState: EditorState;
  modifier: any;
  onChange: (state: EditorState) => void;
}> = ({ editorState, modifier, onChange }) => {
  const ref = React.useRef<HTMLInputElement>(null);

  const { uploadImages } = useImageUpload(
    EPrepImagesSource.BLOG_EMBEDDED_IMAGE
  );

  const [resource, setResource] = React.useState<{ imageId: string }[]>([]);
  const [isLoading, setIsLoading] = React.useState(false);

  const originalDescriptiveResources = React.useMemo(() => [], []);

  const imageInput = React.useMemo(() => {
    return {};
  }, []);

  const { resourcesSyncedWithDraft } = useDraftResources({
    originalDescriptiveResources: originalDescriptiveResources,
    newDescriptiveResourcesIds: resource,
    source: EPrepImagesSource.BLOG_EMBEDDED_IMAGE,
    imageInput: imageInput,
  });

  React.useEffect(() => {
    const draft =
      resource.length > 0 &&
      resourcesSyncedWithDraft.find(
        (draft) => 'imageId' in draft && draft.imageId === resource[0].imageId
      );
    if (!!draft) {
      const firstResource = resource.pop();
      if (firstResource) {
        if (!!draft?.url) {
          onChange(
            modifier(editorState, draft.url, {
              fileId: firstResource.imageId,
            })
          );
        }
      }
    }
  }, [editorState, modifier, onChange, resource, resourcesSyncedWithDraft]);

  return (
    <>
      <Input
        type="file"
        multiple={false}
        accept="image/*"
        onChange={async (event) => {
          setIsLoading(true);
          const files = event.currentTarget.files
            ? Array.from(event.currentTarget.files)
            : [];
          const promisedResources = files.map(async (file) => {
            const resource = await uploadImages([file]);

            return resource ? { imageId: resource[0] } : null;
          });
          const resources = (await Promise.all(promisedResources)).filter(
            (resource): resource is { imageId: string } => !!resource
          );

          setIsLoading(false);
          return setResource([resources[0]]);
        }}
        ref={ref}
        display="none"
      />
      <ButtonGroup w="full" display="flex" justifyContent="flex-end">
        <Button onClick={() => ref.current?.click()} isLoading={isLoading}>
          Browse
        </Button>
      </ButtonGroup>
    </>
  );
};
